/**
 * The main api service
 */
import http from '@util/http';
import { common } from '../req';

export async function queryTalkList(params) {
  return http.get(common.TALK_LIST, params);
}

export async function querySaveTalk(params) {
  return http.post(common.TALK_SAVE, params);
}



// WEBPACK FOOTER //
// ./src/api/common/talk.js